import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function WhatsAppButton() {
  const [phone, setPhone] = useState(null);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setPhone(r.data?.whatsapp || r.data?.phone))
      .catch(() => {});
  }, []);

  if (!phone) return null;

  const digits = phone.replace(/[^\d]/g, "");
  if (!digits) return null;

  return (
    <a
      href={`https://wa.me/${digits}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg transition-transform hover:scale-110"
    >
      <svg viewBox="0 0 32 32" className="h-8 w-8 fill-white" aria-hidden="true">
        <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.61.844 5.022 2.28 6.984L4.99 28l6.184-1.257A11.94 11.94 0 0016.001 27C22.63 27 28 21.627 28 15S22.63 3 16.001 3zm.001 21.818a9.77 9.77 0 01-4.978-1.362l-.357-.212-3.671.746.777-3.585-.233-.368A9.74 9.74 0 016.182 15c0-5.415 4.404-9.818 9.819-9.818 5.415 0 9.818 4.403 9.818 9.818 0 5.415-4.403 9.818-9.817 9.818zm5.361-7.354c-.294-.147-1.74-.858-2.01-.956-.27-.098-.467-.147-.663.147-.196.294-.76.956-.932 1.152-.171.196-.343.22-.637.073-.294-.147-1.242-.458-2.365-1.462-.874-.78-1.464-1.744-1.636-2.038-.171-.294-.018-.453.129-.6.132-.132.294-.343.44-.514.147-.171.196-.294.294-.49.098-.196.049-.368-.024-.514-.073-.147-.663-1.597-.909-2.187-.24-.576-.484-.498-.663-.507l-.564-.01c-.196 0-.514.073-.783.368-.269.294-1.027 1.004-1.027 2.45s1.052 2.842 1.198 3.038c.147.196 2.07 3.16 5.016 4.432.701.303 1.248.484 1.675.62.704.224 1.344.192 1.85.117.564-.084 1.74-.711 1.985-1.397.245-.687.245-1.275.171-1.397-.073-.122-.269-.196-.563-.343z" />
      </svg>
    </a>
  );
}
